import axios from "axios";
import LZUTF8 from "lzutf8";
import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import QRCode from "qrcode";

const apiClient = axios.create({
  baseURL:
    window.location.hostname === "localhost"
      ? "http://localhost:3001/api"
      : "/api",
});

export const createBlob = async (content) => {
  const {
    data: { key },
  } = await apiClient.post("/blobs", content);

  return key;
};

export const getBlob = async (key) => {
  const { data } = await apiClient.get(`/blobs/${key}`);

  return data;
};

export const generatePrintUrl = (content, absolute = true) =>
  `${
    absolute ? `${window.location.protocol}//${window.location.host}` : ""
  }/print#${LZUTF8.compress(JSON.stringify(content), {
    outputEncoding: "Base64",
  })}`;

export const notifyAdmin = (message) => apiClient.post("/notify", { message });

export const notifyCustomer = (key, itemId, qrCode, total, contactEmail) =>
  apiClient.post(`/blobs/${key}/notify`, {
    itemId,
    domain: `${window.location.protocol}//${window.location.host}`,
    qrCode,
    total,
    contactEmail,
  });

export const getOrderNumber = async () => {
  const {
    data: { orderNumber },
  } = await apiClient.post("/orderNumber");

  return orderNumber;
};

export const getQRCode = (url) =>
  new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");
    canvas.style.display = "none";
    document.body.appendChild(canvas);

    QRCode.toCanvas(canvas, url, (error) => {
      if (error) {
        reject(error);
      } else {
        resolve(canvas.toDataURL());
      }

      document.body.removeChild(canvas);
    });
  });

export const doPrint = (contact, blobUrl, itemId) => {
  const newWindow = window.open("about:blank");

  getQRCode(blobUrl).then((qrCode) => {
    const base64Html = btoa(
      unescape(
        encodeURIComponent(
          renderToStaticMarkup(
            <div
              style={{
                textAlign: "center",
                fontFamily: "Verdana, sans-serif",
              }}
            >
              <h2>
                {contact.firstName} {contact.lastName}
              </h2>
              <h2>#{itemId}</h2>
              <div>
                {/* eslint-disable-next-line */}
                <img src={qrCode} />
              </div>
            </div>
          )
        )
      )
    );

    fetch(`data:text/html;base64,${base64Html}`)
      .then((res) => res.blob())
      .then((blob) => {
        newWindow.location.href = URL.createObjectURL(blob);

        setTimeout(() => {
          newWindow.focus();
          newWindow.print();
        }, 500);
      });
  });
};
